const messageReducer = (state, action) => {
  switch (action.type) {
    case 'MESSAGE_LIST_LOAD':
      return {
        ...state,
        messageListProgress: true,
        messageList: [],
        messageListIsOld: false,
      };
    case 'MESSAGE_LIST_UPDATE':
      return { ...state, messageListProgress: true, messageListIsOld: false };
    case 'MESSAGE_LIST_SUCCESS':
      return {
        ...state,
        messageListProgress: false,
        messageListLoaded: true,
        messageList: action.messageList,
      };
    case 'MESSAGE_LIST_ERROR':
      return {
        ...state,
        messageListProgress: false,
        messageListLoaded: true,
        messageListError: action.error,
      };
    case 'MESSAGE_MODERATOR_NEW':
      return { ...state, messageList: [action.post, ...state.messageList] };
    case 'MESSAGE_NEW': {
      const withoutTempMessages = state.messageList.filter(
        (msg) => !msg.hasOwnProperty('tempText')
      );
      return {
        ...state,
        messageList: [action.post, ...withoutTempMessages].slice(0, 100),
      };
    }
    case 'MESSAGE_MODERATE_SUCCESS': {
      let newMessageList = [...state.messageList];
      var foundIndex = newMessageList.findIndex(
        (item) => item.id === action.post.id
      );
      newMessageList[foundIndex] = action.post;
      return { ...state, messageList: newMessageList };
    }
    case 'MESSAGE_POST_LOAD':
      return {
        ...state,
        messagePostProgress: true,
        messagePostError: null,
        messageList: [{ tempText: action.post.text }, ...state.messageList],
      };
    case 'MESSAGE_POST_SUCCESS':
      return {
        ...state,
        messagePostProgress: false,
        messagePostSuccess: true,
        messagePost: action.post,
        messagePostError: null,
        messageListIsOld: true,
      };
    case 'MESSAGE_POST_ERROR':
      return {
        ...state,
        messagePostProgress: false,
        messagePostSuccess: false,
        messagePostError: action.error,
      };
    default:
      return state;
  }
};

export default messageReducer;
